export default __webpack_public_path__ + "static/media/SansWeb-RegularItalic.cdd730b3.woff2";